import { atom, useAtom, useSetAtom } from "jotai";

export const selectedCreatorsAtom = atom<string[]>([]);
export const useSelectedCreatorsContext = () => useAtom(selectedCreatorsAtom);
export const useSetSelectedCreators = () => useSetAtom(selectedCreatorsAtom);
